import { render } from "./ThemeRoot.vue?vue&type=template&id=31d9d992&ts=true"
import script from "./ThemeRoot.vue?vue&type=script&lang=ts"
export * from "./ThemeRoot.vue?vue&type=script&lang=ts"

import "./ThemeRoot.vue?vue&type=style&index=0&id=31d9d992&lang=scss"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\eye-concat-program-list\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__